import { Component, OnInit } from "@angular/core";
import "leaflet";
import 'leaflet-draw';
import * as shp from "shpjs";
 declare let L;
@Component({
	selector: "app-root",
	templateUrl: "./supervisor.component.html",
	styleUrls: ["./supervisor.component.css"]
})
export class SupervisorComponent implements OnInit{

	polygonArray : any= [];
	showElement:Boolean = false;
	constructor() {


	   }
	ngOnInit(): void {
		var polyLayers = [];
    var polyLayer = [];
    var api_key = "wly6pnqvmbuioatp8an1zigi6n3h6mntxr5c4mxw";
		const container = document.getElementById('map1')
    //var m = L.map(container).setView([51.505, -0.09], 13);
    var m = L.map(container).setView([-30.5595,22.9375], 8);

L.tileLayer("https://api.maps.geoint.africa/v1/"+api_key+"/tile/{x}/{y}/{z}.png?settings=global-decarta_TT").addTo(m);
		  const geo = L.geoJson(
			{ features: [] },
			{
				onEachFeature: function popUp(f, l) {
					const out = [];
					if (f.properties) {
						for (const key of Object.keys(f.properties)) {
							out.push(key + " : " + f.properties[key]);
						}
						// l.bindPopup(out.join("<br />"));
						// l.editableLayers();
					}
				}
			}
    ).addTo(m);

    const base = "assets/demo-shapes.zip"; // File Location

		shp(base).then(function(data) {
			console.log("data",data);
			if(data.features.length >1){
				data.features.forEach((feature:any)=>{
					feature.geometry.coordinates.forEach((item:any)=>{
						let itemArray :any =[];
						item.forEach((itemDetail:any)=>{
							console.log(itemDetail[0]);
							itemArray.push([itemDetail[1],itemDetail[0]]);
						})
						console.log("item",item,itemArray);
						polyLayers.push([L.polygon(itemArray),feature.properties]);
						// polyLayer.push(L.polyLayer(itemArray));

					})
				})
			}
			else{
				data.features
				// .forEach((feature:any)=>{
					// feature.
					[0].geometry.coordinates.forEach((item:any)=>{
						let itemArray :any =[];
						item.forEach((itemDetail:any)=>{
							console.log(itemDetail[0]);
							itemArray.push([itemDetail[1],itemDetail[0]]);
						})
						console.log("item",item,itemArray);
						polyLayers.push(L.polygon(itemArray));
					})
				// })
			}

			geo.addData(data);

			// console.log("polygonArray",this.polygonArray);
		});
		// console.log("this.polygoan",this,polygonArray);
		setTimeout(() => {
			console.log('hide');
			this.showElement = true;
			console.log(polyLayers,polyLayer)
			this.polygonArray = polyLayers;
		console.log("polygonArray",this.polygonArray);
		  }, 3000);


}
}
